import {callApi} from '../api'

export const GET_CALENDAR_VACATIONS = 'GET_CALENDAR_VACATIONS';
export const GET_CALENDAR_HOLIDAYS = 'GET_CALENDAR_HOLIDAYS';

export function getCalendarVacations(cb) {
    return function (dispatch, getState) {
        return callApi(dispatch, getState, 'GET', '/vacations', null, GET_CALENDAR_VACATIONS, cb);
    }
}

export function getCalendarHolidays(cb) {
    return function (dispatch, getState) {
        return callApi(dispatch, getState, 'GET', '/holidays', null, GET_CALENDAR_HOLIDAYS, cb);
    }
}



// WEBPACK FOOTER //
// ./src/actions/calendar.js